module.exports = __webpack_public_path__ + "static/media/ricochet.20f26c5b.mp3";